import type { FontOptions } from "@gameApp/helpers/canvas/types";

/**
 * @example
 * getContextFont({
 *   weight: 600,
 *   size: 12,
 * }) // returns "600 12px InterForCanvas, sans-serif"
 */
export function getContextFont(options: FontOptions): string {
  const {
    weight,
    size = 12,
    fontFamily = "InterForCanvas, sans-serif",
  } = options;

  const sizeString = Number.isFinite(size) && size > 0 ? `${size}px` : size;

  return [weight, sizeString, fontFamily].filter(Boolean).join(" ");
}
